import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // for current path
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Footer from "./common/footer/footer";
import NavigationBar from "./common/navigation/navigation";
import ScrollUpButton from "./components/scroll-up-button/scroll-up-button";
import LoadingOverlay from "./components/loading/LoadingOverlay";

function App() {
  const [hasStartedForever, setHasStartedForever] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isPasswordPromptVisible, setIsPasswordPromptVisible] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  const location = useLocation(); // get current route path
  const pw = "Ella&Chris2026";

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, []);

  // Load from sessionStorage
  // useEffect(() => {
  //   const started = sessionStorage.getItem("hasStartedForever") === "true";
  //   setHasStartedForever(started);

  //   const authorized = sessionStorage.getItem("authorized") === "true";
  //   setIsAuthorized(authorized);
  // }, []);

  const handleStartClick = () => setIsPasswordPromptVisible(true);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === pw) {
      sessionStorage.setItem("hasStartedForever", "true");
      sessionStorage.setItem("authorized", "true");
      setHasStartedForever(true);
      setIsAuthorized(true);
    } else {
      alert("Incorrect password. Try again.");
    }
    setPasswordInput("");
  };

  const show_svg = {
    src: `${process.env.PUBLIC_URL}/images/icons/eye-password-show.svg`,
    alt: "Show Password",
  };
  const hide_svg = {
    src: `${process.env.PUBLIC_URL}/images/icons/eye-password-hide.svg`,
    alt: "Hide Password",
  };

  // List of routes that bypass the password gate
  const publicRoutes = [
    "/save-the-date",
    "/e-invite",
    "/meal-preferences",
    "/find-your-table",
  ];

  // If on a public route, just render routes directly
  if (publicRoutes.includes(location.pathname)) {
    return <AppRoutes />;
  }

  // Show landing page if not authorized
  // if (!hasStartedForever || !isAuthorized) {
  //   return (
  //     <>
  //       <LoadingOverlay isLoading={!imagesLoaded} />

  //       <div className="main-landing">
  //         <div className="main-landing-bg"></div>
  //         <div className="main-title">
  //           <h1 className="cormorant-light-400 letter-spacing-8">
  //             CHRIS RALLOS & ELLA DIAZ
  //           </h1>
  //           <div className="pw-form">
  //             {!isPasswordPromptVisible && (
  //               <button className="pw-btn" onClick={handleStartClick}>
  //                 THE START OF OUR FOREVER
  //               </button>
  //             )}

  //             {isPasswordPromptVisible && (
  //               <form className="password-form" onSubmit={handlePasswordSubmit}>
  //                 <div className="pw-input-container">
  //                   <input
  //                     type={showPassword ? "text" : "password"}
  //                     value={passwordInput}
  //                     onChange={(e) => setPasswordInput(e.target.value)}
  //                     placeholder="Enter password"
  //                   />
  //                   <button
  //                     type="button"
  //                     className="eye-btn"
  //                     onClick={toggleShowPassword}
  //                     aria-label={
  //                       showPassword ? "Hide password" : "Show password"
  //                     }
  //                   >
  //                     <img
  //                       className="show-hide-btn"
  //                       src={showPassword ? hide_svg.src : show_svg.src}
  //                       alt={showPassword ? hide_svg.alt : show_svg.alt}
  //                       width={20}
  //                       height={20}
  //                     />
  //                   </button>
  //                 </div>
  //                 <button className="pw-btn" type="submit">
  //                   SUBMIT
  //                 </button>
  //               </form>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // }

  // Show protected app layout
  return (
    <>
      <header className="position-relative">
        <NavigationBar />
      </header>
      <div className="scroll-wrapper">
        <main className="main texture-bg position-relative width-100">
          <AppRoutes />
        </main>
      </div>
      <ScrollUpButton />
      <footer className="position-relative">
        <Footer />
      </footer>
    </>
  );
}

export default App;
